import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Geolocation, Position, PositionOptions } from '@capacitor/geolocation';
import { SessionService } from '@core/services/session.service';
import { Platform } from '@ionic/angular';
import { BehaviorSubject, from, Observable, of, switchMap } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class GpsService implements OnDestroy {
  private positionSubject = new BehaviorSubject<Position | null>(null);
  public position$ = this.positionSubject.asObservable();
  private watcherId: Promise<string>;
  private readonly opts: PositionOptions = { enableHighAccuracy: true, maximumAge: 0 };
  constructor(public platform: Platform, private _router: Router, private sessionService: SessionService) {
    this.sessionService.logout$.subscribe(() => this.stopWatch());
  }
  currentPosition(opts: PositionOptions = this.opts): Promise<Position> {
    console.log('consultando ubicacion');
    return Geolocation.getCurrentPosition(opts);
  }
  startWatch(opts: PositionOptions = this.opts): Observable<Position | null> {
    return from(this.checkAndRequestLocationPermission()).pipe(
      switchMap((granted) => {
        if (!granted) {
          return of(null);
        }
        if (this.watcherId) {
          return this.position$;
        }
        this.watcherId = Geolocation.watchPosition(opts || {}, (position: Position, err: any) => {
          if (position) {
            this.positionSubject.next(position);
          }
        });
        return this.position$;
      }),
    );
  }
  ngOnDestroy(): void {
    this.stopWatch();
  }
  async stopWatch(): Promise<void> {
    if (this.watcherId) {
      await Geolocation.clearWatch({ id: await this.watcherId });
      this.watcherId = null;
    }
  }
  async checkAndRequestLocationPermission() {
    if (!this.platform.is('capacitor')) {
      return true;
    } else {
      const permissionStatus = await Geolocation.checkPermissions();
      if (permissionStatus.location === 'granted') {
        return true;
      } else {
        await this._router.navigate(['gps/consent'], { queryParams: { redirectUrl: '/home/dashboard' } });
        return false;
      }
    }
  }
}
